import React, { Component } from "react";
import Accordion from "../UI/Accordion";
import RadioInput from "../UI/RadioInput";
import DatePicker from "react-datepicker";
import setHours from "date-fns/setHours";
import setMinutes from "date-fns/setMinutes";
import moment from "moment/moment";
import { leadSubmissionApi } from "../../services/leadSubmissionApi";
import { leadSubmissionLMPApi } from "../../services/leadSubmissionLMPApi";
import "react-datepicker/dist/react-datepicker.css";
import WindowWarning from "../WindowWarning";
import { startOfDay } from "date-fns";

export class Quote extends Component {
    submission = (e) => {
        e.preventDefault();
        this.props.nextStep();

        const leadSubmissionService = new leadSubmissionLMPApi(
            this.props,
            this.props.handleLeadSubmission
        );
        leadSubmissionService.submitLead(true).then((leadSuccess) => {
            if (leadSuccess) {
                console.log("Lead Success");
            } else {
                console.log("Lead Failed");
                this.props.handleOnlineBookingFinalResponse(leadSuccess);
            }
        });
    };

    continue = (e) => {
        e.preventDefault();

        //Moving to Loading State
        this.props.nextStep();

        //Submit Lead
        const leadSubmissionService = new leadSubmissionApi(
            this.props,
            this.props.handleLeadSubmission
        );

        leadSubmissionService.submitLead(true).then((leadSuccess) => {
            if (leadSuccess) {
                console.log("Lead Success");
            } else {
                console.log("Lead Failed");
            }
        });

        try {
            if (typeof ga === "function") {
                var fields = {
                    hitType: "event",
                    event_category: "Appointment",
                    eventAction: "Booked Appointment",
                    value: "5",
                };

                window.gtag("event", fields.eventAction, fields);
            }
        } catch (err) {
            console.log(
                "Error Logging Google Analytics Event for Step 5 - Online booking"
            );
        }
    };

    componentDidMount() {
        window.scrollTo(0, 0);
    }


    SetOperatingHoursByDay(dateValue) {
        let date = new Date(dateValue);
        let day = date.getDay();
        let operatingHourArray = [];
        console.log(date);
        switch (day) {
            case 1:
                operatingHourArray = this.parseOperatingHours(
                    document.getElementById("AgentPreferenceMondayHours").value,
                    date.toString()
                );
                break;
            case 2:
                operatingHourArray = this.parseOperatingHours(
                    document.getElementById("AgentPreferenceTuesdayHours").value,
                    date.toString()
                );
                break;
            case 3:
                operatingHourArray = this.parseOperatingHours(
                    document.getElementById("AgentPreferenceWednesdayHours").value,
                    date.toString()
                );
                break;
            case 4:
                operatingHourArray = this.parseOperatingHours(
                    document.getElementById("AgentPreferenceThursdayHours").value,
                    date.toString()
                );

                break;
            case 5:
                operatingHourArray = this.parseOperatingHours(
                    document.getElementById("AgentPreferenceFridayHours").value,
                    date.toString()
                );
                break;
            default: //if Sunday or Saturday apply operating hours for Monday
                operatingHourArray = this.parseOperatingHours(
                    document.getElementById("AgentPreferenceMondayHours").value,
                    date.toString()
                );
                break;
        }

        let agentAppointmentBusySlotsOriginalArray = this.parseBusyAppointmentSlots(
            document.getElementById("AgentAppointmentBusy").value
        );
        let busyTimeSlotsForSelectedDate = [];
        let isStackingAllow =
            document.getElementById("IsAppointmentstackingAllow").value === "True"
                ? true
                : false;
        for (var i = 0; i < agentAppointmentBusySlotsOriginalArray.length; i++) {
            if (
                agentAppointmentBusySlotsOriginalArray[i].getDate() === date.getDate()
            ) {
                busyTimeSlotsForSelectedDate.push(
                    agentAppointmentBusySlotsOriginalArray[i]
                );
            }
        }

        //Remove busy hour(s) from selected day based on is stacking appointment allowed AND busyTimeSlotsForSelectedDate array is not empty
        if (busyTimeSlotsForSelectedDate.length > 0 && !isStackingAllow) {
            operatingHourArray = operatingHourArray.filter((s) =>
                busyTimeSlotsForSelectedDate.every((e) => e.toString() !== s.toString())
            );
        }

        //console.log("result after fillered (first time) -------");
        //console.log(operatingHourArray);

        return operatingHourArray;
    }

    parseOperatingHours(Hourdata, dateValue) {

        if (!Hourdata) return [];

        const allowedTimes = Hourdata
            .split(",")
            .map(h => parseFloat(h.trim()))
            .map(h => {
                const hour = Math.floor(h);
                const minutes = h % 1 === 0.5 ? 30 : 0;

                // IMPORTANT: always start with a fresh Date()
                let d = new Date(dateValue);
                d = setMinutes(d, minutes);
                d = setHours(d, hour);

                return d; // <-- MUST be a Date object
            });

        return allowedTimes;
    }

    parseBusyAppointmentSlots(busy) {
        if (!busy) return [];
        let parsedSlotData = [];
        let finalSlotData = [];
        let slotArr = [];

        if (!Array.isArray(busy) && typeof busy === "string") {
            slotArr = busy.split(",");
        }
        else {
            slotArr = busy;
        }

        slotArr.forEach((element) => {
            var a = new Date(element);
            var b = a.toString();
            parsedSlotData.push(b);
        });

        let uniqueChars = [];
        parsedSlotData.forEach((element) => {
            if (!uniqueChars.includes(element)) {
                uniqueChars.push(element);
            }
        });

        uniqueChars.forEach((element) => {
            finalSlotData.push(new Date(element));
        });
        return finalSlotData;
    }


    render() {
        const {
            values,
            handleAptDateChange,
            handleTimeChange,
            handleLeadSubmission,
        } = this.props;

        let diff = this.props.values.movingDate - new Date();
        let isMoveWithin7Days = diff <= 604800000; //Diff in 7 Days in millisecond
        let isLMPID = this.props.values.isDataByLMPID;
        let errorMessage = this.props.values.errorMsg;

        const isWeekday = (date) => {
            const day = date.getDay();
            return day !== 0 && day !== 6;
        };
        //const defaultOperatingHours = (date) => {
        //    const day = date.getDay();
        //    console.log("not activate");
        //    console.log(this.props.values.agentPreferenceWednesdayHours);
        //    if (day === 3)//Wednesday
        //    {

        //        console.log("activate");
        //        console.log(this.props.values.agentPreferenceWednesdayHours);
        //        parseOperatingHours(this.props.values.agentPreferenceWednesdayHours);
        //        return new Array(parseOperatingHours(this.props.values.agentPreferenceWednesdayHours));
        //    }
        //    console.log("return null");
        //    return null;

        //};
        const normalizeHolidayDates = (raw) => {
            if (!raw) return [];
            if (Array.isArray(raw)) {
                return raw.map((d) => startOfDay(new Date(d))).filter((d) => !isNaN(d));
            }
            if (typeof raw === "string" && raw.includes(",")) {
                return raw
                    .split(",")
                    .map((s) => startOfDay(new Date(s.trim())))
                    .filter((d) => !isNaN(d));
            }
            const d = startOfDay(new Date(raw));
            return isNaN(d) ? [] : [d];
        };

        const holidayDates = normalizeHolidayDates(
            values.agentAppointmentNextHoliday
        );
        // Debug once to confirm:
        console.log(
            "holidayDates ->",
            holidayDates,
            holidayDates.map((d) => d instanceof Date)
        );
        return (
            <div className="ob-bg">
                <div className="ob-wrapper">
                    <div className="ob-quote">
                        {isLMPID ? ( //Quote with lead ID
                            errorMessage === "" ? (
                                <>
                                    <WindowWarning
                                        enable
                                        submitLead
                                        values={values}
                                        handleLeadSubmission={handleLeadSubmission}
                                    />
                                    <div className="ob-quote__appointment-box">
                                        <h2 className="ob-h2">
                                            {document.getElementById("Step4Title").value}
                                        </h2>
                                        <p className="ob-quote__paragraph">
                                            {document.getElementById("Step4BookingDescription").value}
                                        </p>
                                        <Accordion title="Select a date and time" open={true}>
                                            {/* <DatePicker
                                                selected={values.appointmentDate}
                                                onChange={(date) => handleAptDateChange(date)}
                                                name="appointmentDate"
                                                dateFormat="MM/dd/yyyy"
                                                minDate={values.agentAppointmentStartDate}
                                                maxDate={values.movingDate - 604800000}
                                                filterDate={isWeekday}
                                                // excludeDates={values.agentAppointmentNextHoliday}
                                                inline
                                                //formatWeekDay={(nameOfDay) => nameOfDay.substr(0, 1)}
                                            /> */}
                                            <DatePicker
                                                selected={values.appointmentDate}
                                                onChange={(date) => handleAptDateChange(date)}
                                                name="appointmentDate"
                                                dateFormat="MM/dd/yyyy"
                                                minDate={values.agentAppointmentStartDate}
                                                maxDate={new Date(values.movingDate - 604800000)}
                                                filterDate={isWeekday}
                                                //   filterDate={(d) => d.getDay() !== 0 && d.getDay() !== 6} // keep if you want weekdays only
                                                excludeDates={holidayDates}
                                                inline
                                            />
                                            <DatePicker
                                                selected={values.appointmentTime}
                                                onChange={(date) => handleTimeChange(date)}
                                                excludeTimes={values.agentAppointmentBusySlotsUpdated}
                                                includeTimes={this.SetOperatingHoursByDay(values.appointmentDate)}
                                                inline
                                                name="appointmentTime"
                                                showTimeSelect
                                                showTimeSelectOnly
                                                timeFormat="hh:mm aa"
                                                timeIntervals={60}
                                            />
                                        </Accordion>
                                        <div className="ob-btn__fixed-container">
                                            <button
                                                className="ob-btn ob-btn--full"
                                                onClick={this.submission}
                                            >
                                                {
                                                    document.getElementById("Step4BookingButtonText")
                                                        .value
                                                }
                                            </button>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <h2>{this.props.values.errorMsg}</h2>
                                </>
                            )
                        ) : //If IsDataByLMPID is false

                            isMoveWithin7Days || this.props.values.isOutOfAreaMove ? (
                                <>
                                    <div class="ob-quote__appointment-box">
                                        <h2 class="ob-h2 call-msg">
                                            To get a guaranteed rate with one of our in house estimators
                                            call {document.getElementById("PhoneNumToShow").value}.
                                        </h2>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <WindowWarning
                                        enable
                                        submitLead
                                        values={values}
                                        handleLeadSubmission={handleLeadSubmission}
                                    />
                                    <div className="ob-quote__appointment-box">
                                        <h2 className="ob-h2">Schedule an Appointment</h2>
                                        <p className="ob-quote__paragraph">
                                            {document.getElementById("Step4BookingDescription").value}
                                        </p>
                                        <Accordion title="Select a date and time" date open={true}>
                                            {/* <DatePicker
                                                selected={values.appointmentDate}
                                                onChange={(date) => handleAptDateChange(date)}
                                                name="appointmentDate"
                                                dateFormat="MM/dd/yyyy"
                                                minDate={values.agentAppointmentStartDate}
                                                maxDate={values.movingDate - 604800000}
                                                filterDate={isWeekday}
                                                excludeDates={values.agentAppointmentNextHoliday}
                                                inline
                                                formatWeekDay={(nameOfDay) => nameOfDay.substr(0, 1)}
                                            /> */}
                                            <DatePicker
                                                selected={values.appointmentDate}
                                                onChange={(date) => handleAptDateChange(date)}
                                                name="appointmentDate"
                                                dateFormat="MM/dd/yyyy"
                                                minDate={values.agentAppointmentStartDate}
                                                maxDate={new Date(values.movingDate - 604800000)}
                                                excludeDates={holidayDates}
                                                inline
                                                formatWeekDay={(nameOfDay) => nameOfDay.substr(0, 1)}
                                            />
                                            <DatePicker
                                                selected={values.appointmentTime}
                                                onChange={(date) => handleTimeChange(date)}
                                                excludeTimes={values.agentAppointmentBusySlotsUpdated}
                                                //includeTimes = {values.agentOperatingHours}
                                                //excludeDates={values.agentAppointmentBusySlots}
                                                inline
                                                name="appointmentTime"
                                                showTimeSelect
                                                showTimeSelectOnly
                                                timeFormat="hh:mm aa"
                                                timeIntervals={60}
                                                minTime={setHours(setMinutes(new Date(), 0), 9)}
                                                maxTime={setHours(setMinutes(new Date(), 45), 16)}
                                            />
                                        </Accordion>
                                        <div className="ob-btn__fixed-container">
                                            <button
                                                className="ob-btn ob-btn--full"
                                                onClick={this.continue}
                                            >
                                                {document.getElementById("Step4BookingButtonText").value}
                                            </button>
                                        </div>
                                    </div>
                                </>
                            )}
                    </div>
                </div>
            </div>
        );
    }
}

export default Quote;
